// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `datepicker {
  background: blue;
}
.TKrmOQpT7gppYcZhunNB {
  padding: 20px;
  color: white;
  font-size: 16px;
  text-transform: uppercase;
  font-weight: bold;
  line-Height: 2;
  background-color: #d32f2f;
  
}
.xx5zxVVmuKBekuv73_Up {
  padding: 20px;
  color: white;
  font-size: 16px;
  text-transform: uppercase;
  font-weight: bold;
  line-Height: 2;
  background-color: #43a047;
}
.myfkp8C7ppdQJpWNj7Vg {
  line-height: 1em;
  position: relative;
  outline: 0;
  border: 0;
  color: black;
  text-align: center;
  height: 1.5em;
  opacity: 0.5;
}
.myfkp8C7ppdQJpWNj7Vg:before {
  content: '';
  background: linear-gradient(to right, transparent, #818078, transparent);
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  height: 1px;
}
.myfkp8C7ppdQJpWNj7Vg:after {
  content: attr(data-content);
  position: relative;
  left: -66px;
  display: inline-block;
  color: black;
  padding: 0 0.5em;
  line-height: 1.5em;
  color: #818078;
  background-color: #fcfcfa;
}
.rnZPnuPnkOQ3t8_rffGj {
  margin-right: 20px;
}

.ow0LdKg3BuK0q84B45Rc {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}`, "",{"version":3,"sources":["webpack://./src/styles/common.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;;AAE3B;AACA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;AACA;EACE,WAAW;EACX,wEAAwE;EACxE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B,EAAE,eAAe;IAC1C,yBAAyB,EAAE,WAAW;KACrC,wBAAwB,EAAE,mBAAmB;OAC3C,sBAAsB,EAAE,4BAA4B;QACnD,qBAAqB,EAAE,2BAA2B;YAC9C,iBAAiB,EAAE;gFACiD;AAChF","sourcesContent":["datepicker {\n  background: blue;\n}\n.confirmationError {\n  padding: 20px;\n  color: white;\n  font-size: 16px;\n  text-transform: uppercase;\n  font-weight: bold;\n  line-Height: 2;\n  background-color: #d32f2f;\n  \n}\n.confirmationSuccess {\n  padding: 20px;\n  color: white;\n  font-size: 16px;\n  text-transform: uppercase;\n  font-weight: bold;\n  line-Height: 2;\n  background-color: #43a047;\n}\n.hrText {\n  line-height: 1em;\n  position: relative;\n  outline: 0;\n  border: 0;\n  color: black;\n  text-align: center;\n  height: 1.5em;\n  opacity: 0.5;\n}\n.hrText:before {\n  content: '';\n  background: linear-gradient(to right, transparent, #818078, transparent);\n  position: absolute;\n  left: 0;\n  top: 50%;\n  width: 100%;\n  height: 1px;\n}\n.hrText:after {\n  content: attr(data-content);\n  position: relative;\n  left: -66px;\n  display: inline-block;\n  color: black;\n  padding: 0 0.5em;\n  line-height: 1.5em;\n  color: #818078;\n  background-color: #fcfcfa;\n}\n.marginRight20 {\n  margin-right: 20px;\n}\n\n.noselect {\n  -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n     -khtml-user-select: none; /* Konqueror HTML */\n       -moz-user-select: none; /* Old versions of Firefox */\n        -ms-user-select: none; /* Internet Explorer/Edge */\n            user-select: none; /* Non-prefixed version, currently\n                                  supported by Chrome, Edge, Opera and Firefox */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"confirmationError": `TKrmOQpT7gppYcZhunNB`,
	"confirmationSuccess": `xx5zxVVmuKBekuv73_Up`,
	"hrText": `myfkp8C7ppdQJpWNj7Vg`,
	"marginRight20": `rnZPnuPnkOQ3t8_rffGj`,
	"noselect": `ow0LdKg3BuK0q84B45Rc`
};
module.exports = ___CSS_LOADER_EXPORT___;
